/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
.ux-tab-container {
  display: block;
  position: relative;
}
.ux-tab-container__tab-header {
  justify-content: flex-start;
  align-items: stretch;
  border-bottom: 1px solid #c4c4c4;
  display: flex;
  max-width: 100%;
}
.ux-tab-container__tab-body {
  padding-top: 15px;
}
.ux-tab-container__tab-body--no-gutter {
  padding-top: 0;
}
.ux-tab-container__tab-list {
  align-items: flex-start;
  display: flex;
  flex: 1;
  transition: transform 0.3s ease-in-out;
  width: auto;
}
.ux-tab-container__arrow {
  align-items: center;
  background: var(--ux-tabs-container-arrow-bg-color);
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: center;
  position: absolute;
  top: 0;
  width: 30px;
  z-index: 99;
  /* stylelint-disable max-line-length */
  /* stylelint-enable max-line-length */
  /* stylelint-disable max-line-length */
  /* stylelint-enable max-line-length */
}
.ux-tab-container__arrow ux-icon {
  transition: opacity 0.3s;
}
.ux-tab-container__arrow--right {
  background: linear-gradient(to right, var(--ux-tabs-container-arrow-bg-color-transparent) 0, var(--ux-tabs-container-arrow-bg-color) 18%);
  justify-content: flex-end;
  right: 0;
}
.ux-tab-container__arrow--right.is-overlapping {
  background: linear-gradient(to right, var(--ux-tabs-container-arrow-bg-color-transparent) 0, var(--ux-tabs-container-arrow-bg-color) 35%);
}
.ux-tab-container__arrow--left {
  background: linear-gradient(to left, var(--ux-tabs-container-arrow-bg-color-transparent) 0, var(--ux-tabs-container-arrow-bg-color) 18%);
  justify-content: flex-start;
  left: 0;
}
.ux-tab-container__arrow--left.is-overlapping {
  background: linear-gradient(to left, var(--ux-tabs-container-arrow-bg-color-transparent) 0, var(--ux-tabs-container-arrow-bg-color) 35%);
}
.ux-tab-container__arrow::before {
  content: "";
  height: 100%;
  pointer-events: none;
  position: absolute;
  transition: opacity 0.5s ease;
  width: 10px;
  z-index: -1;
}
.ux-tab-container__arrow.is-overlapping::before {
  width: 34px;
}
.ux-tab-container__arrow--left::before {
  background: linear-gradient(to left, var(--ux-tabs-container-arrow-bg-color-transparent) 0, var(--ux-tabs-container-arrow-bg-color) 80%, var(--ux-tabs-container-arrow-bg-color) 100%);
  left: 20px;
}
.ux-tab-container__arrow--right::before {
  background: linear-gradient(to right, var(--ux-tabs-container-arrow-bg-color-transparent) 0, var(--ux-tabs-container-arrow-bg-color) 80%, var(--ux-tabs-container-arrow-bg-color) 100%);
  right: 20px;
}
.ux-tab-container__arrow--deactivated ux-icon {
  opacity: 0.3;
}
.ux-tab-container .ux-tab-button__label {
  white-space: nowrap;
}
.ux-tab-container--arrows-active .ux-tab-container__tab-header {
  max-width: 100%;
  overflow: hidden;
  position: relative;
}
.ux-tab-container--arrows-active .ux-tab-container__tab-list {
  justify-content: space-between;
  margin-left: 30px;
  margin-right: 30px;
}
.ux-tab-container .ux-tab-container__tab-header--fixed {
  background: var(--ux-tabs-container-header-fixed-bg-color);
  left: 50%;
  position: fixed;
  top: 0;
  transform: translateX(-50%);
  width: 100%;
  z-index: 999;
}
.ux-tab-container--folder .ux-tab-container__tab-header {
  border-style: none;
}
.ux-tab-container--folder .ux-tab-container__arrow {
  background: var(--ux-tabs-container-arrow-bg-color);
}